export default __webpack_public_path__ + "static/media/feeling_bad.fbd00656.svg";